export class MedianWage {
  constructor(
    public alphabetASCIISerial: string,
    public jobTitle: string,
    public marketWage: number,
    public nationalWage: number,
    public experience: string,
  ) {}
}
